var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { SectionFieldPath } from './models/section';
import { ArticleFieldPath } from './models/article';
function draftSuffix(collectionName, isDraft) {
    return isDraft ? collectionName + 'Draft' : collectionName;
}
var excludeDeletedItemsFilter = function (obj) { return !obj.data().deleted; };
var Collection;
(function (Collection) {
    Collection["Project"] = "project";
    Collection["Platform"] = "platform";
    Collection["Resources"] = "resources";
    Collection["Category"] = "category";
    Collection["Section"] = "section";
    Collection["Article"] = "article";
    Collection["Invocation"] = "invocation";
    Collection["UploadedImage"] = "uploadedImage";
    Collection["Configuration"] = "configuration";
    Collection["EXTERNAL"] = "externals";
    Collection["Features"] = "_features";
    Collection["AccessRoles"] = "accessRoles";
    Collection["Chief"] = "chief";
    Collection["Changelog"] = "changelog";
})(Collection || (Collection = {}));
var Invocation;
(function (Invocation) {
    Invocation["Delete"] = "delete";
    Invocation["PublishProcess"] = "publishProcess";
    Invocation["PinProtect"] = "pinProtect";
    Invocation["ProtectCategory"] = "protectCategory";
    Invocation["ChangeStaffCredentials"] = "changeStaffCredentials";
    Invocation["ChangeAccountCredentials"] = "changeAccountCredentials";
})(Invocation || (Invocation = {}));
var Document;
(function (Document) {
    Document["SubscribeNotification"] = "subscribe-notifications";
})(Document || (Document = {}));
var StoreService = /** @class */ (function () {
    function StoreService(store, projectName, isDraft, user) {
        if (isDraft === void 0) { isDraft = false; }
        if (user === void 0) { user = null; }
        this.offline = false;
        this.store = store;
        this.projectID = projectName;
        this.isDraft = isDraft;
        this.user = __assign({}, user);
        this.projectRef = store.collection(Collection.Project).doc(projectName);
        this.articleCollectionRef = this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft));
        this.categoryCollectionRef = this.projectRef.collection(draftSuffix(Collection.Category, this.isDraft));
        this.chiefCategoryRef = this.projectRef.collection(Collection.Chief).doc('db').collection(Collection.Category);
        this.chiefSectionRef = this.projectRef.collection(Collection.Chief).doc('db').collection(Collection.Section);
        this.chiefArticleRef = this.projectRef.collection(Collection.Chief).doc('db').collection(Collection.Article);
        this.changelogSectionRef = this.projectRef
            .collection(Collection.Changelog)
            .doc('db')
            .collection(Collection.Section);
        this.changelogArticleRef = this.projectRef
            .collection(Collection.Changelog)
            .doc('db')
            .collection(Collection.Article);
    }
    //
    // Project
    //
    // fetchProjectConfig returns the project configuration, as deployed to firebase using eir-cli deploy configuration.
    StoreService.prototype.fetchProjectConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.doc(Collection.Configuration + "/project").get()];
                    case 1:
                        doc = _a.sent();
                        return [2 /*return*/, doc.data()];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectFeatures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.Features).doc('enabled').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc === null || !doc.exists) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProject = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.isOffline = function () {
        return this.offline;
    };
    StoreService.prototype.disableNetwork = function () {
        this.offline = true;
        return this.store.disableNetwork();
    };
    StoreService.prototype.enableNetwork = function () {
        this.offline = false;
        return this.store.enableNetwork();
    };
    StoreService.prototype.updateProjectConfiguration = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.Configuration).doc('draft').update(config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // in web we depend on configuration document entity (not on project entity)
    StoreService.prototype.fetchProjectConfigurationDoc = function (isDraft) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(Collection.Configuration)
                            .doc(isDraft ? 'draft' : 'published')
                            .get()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // ------------ CHIEF FUNCTIONS ---------------
    StoreService.prototype.fetchChiefCategoryList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var snapshot, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chiefCategoryRef.orderBy(SectionFieldPath.orderIndex).get()];
                    case 1:
                        snapshot = _a.sent();
                        return [2 /*return*/, snapshot.docs];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefSections = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefSectionRef.orderBy(SectionFieldPath.orderIndex).get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogSections = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changelogSectionRef.orderBy(SectionFieldPath.orderIndex).get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefSectionsByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefSectionRef
                            .where(SectionFieldPath.category, '==', categoryId)
                            .orderBy(SectionFieldPath.orderIndex)
                            .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogSectionsByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changelogSectionRef
                            .where(SectionFieldPath.category, '==', categoryId)
                            .orderBy(SectionFieldPath.orderIndex)
                            .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefSectionByID = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefSectionRef.doc(sectionId).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch section '" + sectionId + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchOrphanArticlesByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chiefArticleRef
                                .where(ArticleFieldPath.Category, '==', categoryId)
                                .where(ArticleFieldPath.Section, '==', null)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchOrphanChangelogArticlesByCategoryId = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.changelogArticleRef
                                .where(ArticleFieldPath.Category, '==', categoryId)
                                .where(ArticleFieldPath.Section, '==', null)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // --------------------------------------------
    //
    // Category
    //
    StoreService.prototype.fetchCategoryList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Category, this.isDraft)).get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                }
            });
        });
    };
    StoreService.prototype.fetchCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Category, this.isDraft))
                            .doc(categoryId)
                            .get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch category '" + categoryId + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefCategoryRef.doc(categoryId).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch category '" + categoryId + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchAllCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var snapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Category, this.isDraft)).get()];
                    case 1:
                        snapshot = _a.sent();
                        return [2 /*return*/, snapshot.docs];
                }
            });
        });
    };
    /** depricated */
    StoreService.prototype.pinProtectCategory = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store
                            .collection(Collection.Invocation)
                            .doc(Invocation.PinProtect)
                            .collection('i_category')
                            .doc(this.projectID)
                            .collection(this.user.uid)
                            .doc()];
                    case 1:
                        doc = _a.sent();
                        return [2 /*return*/, doc.set({ categoryId: data.categoryId, pin: data.pin })];
                }
            });
        });
    };
    StoreService.prototype.protectCategory = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store
                            .collection(Collection.Invocation)
                            .doc(Invocation.ProtectCategory)
                            .collection('i_category')
                            .doc(this.projectID)
                            .collection(this.user.uid)
                            .doc()];
                    case 1:
                        doc = _a.sent();
                        return [2 /*return*/, doc.set({ categoryId: data.categoryId, isProtected: data.status })];
                }
            });
        });
    };
    //
    // Section
    //
    StoreService.prototype.fetchAllSections = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Section, this.isDraft))
                            .orderBy(SectionFieldPath.orderIndex)
                            .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    StoreService.prototype.fetchSectionsInCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Section, this.isDraft))
                            .where(SectionFieldPath.category, '==', categoryId)
                            .orderBy(SectionFieldPath.orderIndex)
                            .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    StoreService.prototype.fetchSectionByID = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Section, this.isDraft))
                            .doc(sectionId)
                            .get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch section '" + sectionId + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.addSection = function (sectionName, categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.projectRef
                        .collection(draftSuffix(Collection.Section, this.isDraft))
                        .add({
                        category: categoryId,
                        name: sectionName,
                        orderIndex: -1,
                    })
                        .then(function (s) { return s.get(); })];
            });
        });
    };
    StoreService.prototype.addChiefSection = function (sectionName, categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.chiefSectionRef
                        .add({
                        category: categoryId,
                        name: sectionName,
                        orderIndex: -1,
                    })
                        .then(function (s) { return s.get(); })];
            });
        });
    };
    StoreService.prototype.addChangelogSection = function (sectionName, categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.changelogSectionRef
                        .add({
                        category: categoryId,
                        name: sectionName,
                        orderIndex: -1,
                    })
                        .then(function (s) { return s.get(); })];
            });
        });
    };
    StoreService.prototype.updateSectionName = function (id, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var section;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Section, this.isDraft)).doc(id)];
                    case 1:
                        section = _a.sent();
                        return [2 /*return*/, section.update({ name: newName })];
                }
            });
        });
    };
    StoreService.prototype.updateChiefSectionName = function (id, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var section;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefSectionRef.doc(id)];
                    case 1:
                        section = _a.sent();
                        return [2 /*return*/, section.update({ name: newName })];
                }
            });
        });
    };
    StoreService.prototype.updateChangelogSection = function (id, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var section;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changelogSectionRef.doc(id)];
                    case 1:
                        section = _a.sent();
                        return [2 /*return*/, section.update({ name: newName })];
                }
            });
        });
    };
    StoreService.prototype.deleteSection = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var section;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store
                            .collection(Collection.Invocation)
                            .doc(Invocation.Delete)
                            .collection('i_section')
                            .doc(this.projectID)
                            .collection(this.user.uid)
                            .doc()];
                    case 1:
                        section = _a.sent();
                        return [2 /*return*/, section.set({ sectionId: id })];
                }
            });
        });
    };
    StoreService.prototype.deleteChiefSection = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.chiefSectionRef.doc(sectionId).delete()];
            });
        });
    };
    StoreService.prototype.deleteChangelogSection = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.changelogSectionRef.doc(sectionId).delete()];
            });
        });
    };
    StoreService.prototype.updateSectionsOrder = function (sorting) {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.batch()];
                    case 1:
                        batch = _a.sent();
                        sorting.forEach(function (s) {
                            var sectionReference = _this.projectRef.collection(draftSuffix(Collection.Section, _this.isDraft)).doc(s.id);
                            batch.update(sectionReference, { orderIndex: s.data().orderIndex });
                        });
                        return [2 /*return*/, batch.commit()];
                }
            });
        });
    };
    StoreService.prototype.updateChiefSectionsOrder = function (sorting) {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                batch = this.store.batch();
                sorting.forEach(function (s) {
                    var sectionReference = _this.chiefSectionRef.doc(s.id);
                    batch.update(sectionReference, { orderIndex: s.data().orderIndex });
                });
                return [2 /*return*/, batch.commit()];
            });
        });
    };
    StoreService.prototype.updateChangelogSectionsOrder = function (sorting) {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                batch = this.store.batch();
                sorting.forEach(function (s) {
                    var sectionReference = _this.changelogSectionRef.doc(s.id);
                    batch.update(sectionReference, { orderIndex: s.data().orderIndex });
                });
                return [2 /*return*/, batch.commit()];
            });
        });
    };
    //
    // Article
    //
    /***
     * Fetch array of articles belong to category
     *
     * @param {string} categoryId - Related category
     * @returns {Promise<Article[]>}
     */
    StoreService.prototype.fetchArticlesInCategory = function (categoryId) {
        return __awaiter(this, void 0, void 0, function () {
            var querySnapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Article, this.isDraft))
                            .where(ArticleFieldPath.Category, '==', categoryId)
                            .where(ArticleFieldPath.Section, '==', null)
                            .orderBy(ArticleFieldPath.orderIndex)
                            .get()];
                    case 1:
                        querySnapshot = _a.sent();
                        return [2 /*return*/, querySnapshot.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    /***
     * Fetch array of articles belong to section
     *
     * @param {string | null | undefined} sectionId - Related section id
     *    * undefined - fetch all articles from category
     *    * null - fetch articles with `null` section id
     *    * string - fetch articles with section id specified
     * @returns {Promise<Article[]>}
     */
    StoreService.prototype.fetchArticleListBySection = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Article, this.isDraft))
                            .where(ArticleFieldPath.Section, '==', sectionId)
                            .orderBy(ArticleFieldPath.orderIndex)
                            .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    StoreService.prototype.fetchAllArticles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef
                            .collection(draftSuffix(Collection.Article, this.isDraft))
                            .orderBy(ArticleFieldPath.orderIndex)
                            .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs.filter(excludeDeletedItemsFilter)];
                }
            });
        });
    };
    StoreService.prototype.fetchAllChiefArticles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chiefArticleRef.orderBy(ArticleFieldPath.orderIndex).get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchAllChangelogArticles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.changelogArticleRef.orderBy(ArticleFieldPath.orderIndex).get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefArticlesBySectionId = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.chiefArticleRef
                                .where(ArticleFieldPath.Section, '==', sectionId)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 2:
                        e_6 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogArticlesBySectionId = function (sectionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.changelogArticleRef
                                .where(ArticleFieldPath.Section, '==', sectionId)
                                .orderBy(ArticleFieldPath.orderIndex)
                                .get()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.docs];
                    case 2:
                        e_7 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft)).doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchChiefArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefArticleRef.doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changelogArticleRef.doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchExternal = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.EXTERNAL).doc(id).get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error("Failed to fetch article '" + id + "'");
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    // TODO: check if its better if we have a whole article object ?
    StoreService.prototype.saveArticle = function (id, newContent, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft)).doc(id)];
                    case 1:
                        doc = _a.sent();
                        if (newContent === null && newName === null) {
                            throw Error("Failed to update article '" + id + "'");
                        }
                        return [2 /*return*/, newContent !== null ? doc.update('content', newContent) : doc.update('name', newName)];
                }
            });
        });
    };
    StoreService.prototype.saveChiefArticle = function (id, newContent, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chiefArticleRef.doc(id)];
                    case 1:
                        doc = _a.sent();
                        if (newContent === null && newName === null) {
                            throw Error("Failed to update article '" + id + "'");
                        }
                        return [2 /*return*/, newContent !== null ? doc.update('content', newContent) : doc.update('name', newName)];
                }
            });
        });
    };
    StoreService.prototype.saveChangelogArticle = function (id, newContent, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changelogArticleRef.doc(id)];
                    case 1:
                        doc = _a.sent();
                        if (newContent === null && newName === null) {
                            throw Error("Failed to update article '" + id + "'");
                        }
                        return [2 /*return*/, newContent !== null ? doc.update('content', newContent) : doc.update('name', newName)];
                }
            });
        });
    };
    StoreService.prototype.addArticle = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            var collection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(draftSuffix(Collection.Article, this.isDraft))];
                    case 1:
                        collection = _a.sent();
                        return [2 /*return*/, collection.add(article).then(function (a) { return a.get(); })];
                }
            });
        });
    };
    StoreService.prototype.addChiefArticle = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.chiefArticleRef.add(article).then(function (a) { return a.get(); })];
            });
        });
    };
    StoreService.prototype.addChangelogArticle = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.changelogArticleRef.add(article).then(function (a) { return a.get(); })];
            });
        });
    };
    StoreService.prototype.deleteArticle = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var article;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store
                            .collection(Collection.Invocation)
                            .doc(Invocation.Delete)
                            .collection('i_article')
                            .doc(this.projectID)
                            .collection(this.user.uid)
                            .doc()];
                    case 1:
                        article = _a.sent();
                        return [2 /*return*/, article.set({ articleId: id })];
                }
            });
        });
    };
    StoreService.prototype.deleteChiefArticle = function (articleId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.chiefArticleRef.doc(articleId).delete()];
            });
        });
    };
    StoreService.prototype.deleteChangelogArticle = function (articleId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.changelogArticleRef.doc(articleId).delete()];
            });
        });
    };
    StoreService.prototype.fetchRegularArticleList = function (ids, failWhenAnyArticleFails) {
        if (failWhenAnyArticleFails === void 0) { failWhenAnyArticleFails = true; }
        return __awaiter(this, void 0, void 0, function () {
            var fetchArticles;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchArticles = ids.map(function (id) {
                            return _this.fetchArticle(id).catch(function (e) {
                                if (failWhenAnyArticleFails) {
                                    throw e;
                                }
                                else {
                                    return null;
                                }
                            });
                        });
                        return [4 /*yield*/, Promise.all(fetchArticles)];
                    case 1: return [2 /*return*/, (_a.sent()).filter(function (article) { return article != null; })];
                }
            });
        });
    };
    // For bookmarks
    StoreService.prototype.fetchChiefArticleList = function (ids, failWhenAnyArticleFails) {
        if (failWhenAnyArticleFails === void 0) { failWhenAnyArticleFails = true; }
        return __awaiter(this, void 0, void 0, function () {
            var fetchChiefArticles;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchChiefArticles = ids.map(function (id) {
                            return _this.fetchChiefArticle(id).catch(function (e) {
                                if (failWhenAnyArticleFails) {
                                    throw e;
                                }
                                else {
                                    return null;
                                }
                            });
                        });
                        return [4 /*yield*/, Promise.all(fetchChiefArticles)];
                    case 1: return [2 /*return*/, (_a.sent()).filter(function (article) { return article != null; })];
                }
            });
        });
    };
    StoreService.prototype.fetchChangelogArticleList = function (ids, failWhenAnyArticleFails) {
        if (failWhenAnyArticleFails === void 0) { failWhenAnyArticleFails = true; }
        return __awaiter(this, void 0, void 0, function () {
            var fetchChiefArticles;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchChiefArticles = ids.map(function (id) {
                            return _this.fetchChangelogArticle(id).catch(function (e) {
                                if (failWhenAnyArticleFails) {
                                    throw e;
                                }
                                else {
                                    return null;
                                }
                            });
                        });
                        return [4 /*yield*/, Promise.all(fetchChiefArticles)];
                    case 1: return [2 /*return*/, (_a.sent()).filter(function (article) { return article != null; })];
                }
            });
        });
    };
    StoreService.prototype.fetchArticleList = function (ids, failWhenAnyArticleFails) {
        if (failWhenAnyArticleFails === void 0) { failWhenAnyArticleFails = true; }
        return __awaiter(this, void 0, void 0, function () {
            var regular, chief, changelog, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        regular = this.fetchRegularArticleList(ids, failWhenAnyArticleFails);
                        chief = this.fetchChiefArticleList(ids, failWhenAnyArticleFails);
                        changelog = this.fetchChangelogArticleList(ids, failWhenAnyArticleFails);
                        return [4 /*yield*/, regular];
                    case 1:
                        _b = (_a = (_d.sent())).concat;
                        return [4 /*yield*/, chief];
                    case 2:
                        _c = [_d.sent()];
                        return [4 /*yield*/, changelog];
                    case 3: return [2 /*return*/, _b.apply(_a, _c.concat([_d.sent()]))];
                }
            });
        });
    };
    StoreService.prototype.updateArticlesOrder = function (sorting) {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.batch()];
                    case 1:
                        batch = _a.sent();
                        sorting.forEach(function (a) {
                            var articleReference = _this.projectRef.collection(draftSuffix(Collection.Article, _this.isDraft)).doc(a.id);
                            batch.update(articleReference, { orderIndex: a.data().orderIndex, section: a.data().section });
                        });
                        return [2 /*return*/, batch.commit()];
                }
            });
        });
    };
    StoreService.prototype.updateChiefArticlesOrder = function (sorting) {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                batch = this.store.batch();
                sorting.forEach(function (a) {
                    var articleReference = _this.chiefArticleRef.doc(a.id);
                    batch.update(articleReference, { orderIndex: a.data().orderIndex, section: a.data().section });
                });
                return [2 /*return*/, batch.commit()];
            });
        });
    };
    StoreService.prototype.updateChangelogArticlesOrder = function (sorting) {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                batch = this.store.batch();
                sorting.forEach(function (a) {
                    var articleReference = _this.changelogArticleRef.doc(a.id);
                    batch.update(articleReference, { orderIndex: a.data().orderIndex, section: a.data().section });
                });
                return [2 /*return*/, batch.commit()];
            });
        });
    };
    //
    // Other
    //
    StoreService.prototype.fetchAllData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fetchProject, fetchLegalDocuments, fetchProjectMetadata, fetchPlatformMetadata, fetchCollections, e_8;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchProject = this.fetchProject();
                        fetchLegalDocuments = this.fetchLegalDocuments();
                        fetchProjectMetadata = [this.fetchProjectJs(), this.fetchProjectCss()];
                        fetchPlatformMetadata = [this.fetchPlatformJs(), this.fetchPlatformCss()];
                        fetchCollections = [
                            Collection.Category,
                            Collection.Section,
                            Collection.Article,
                        ].map(function (type) { return _this.projectRef.collection(draftSuffix(type, _this.isDraft)).get(); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(__spreadArrays([
                                fetchProject,
                                fetchLegalDocuments
                            ], fetchCollections, fetchProjectMetadata, fetchPlatformMetadata))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_8 = _a.sent();
                        // eslint-disable-next-line no-undef
                        console.warn('Failed to fetch Firestore data:', e_8.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreService.prototype.fetchAllImages = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.UploadedImage).get()];
                    case 1: return [2 /*return*/, (_a.sent()).docs];
                }
            });
        });
    };
    StoreService.prototype.registerFirebaseCloudMessageToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var collectionRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        collectionRef = this.store
                            .collection(Collection.Invocation)
                            .doc(Document.SubscribeNotification)
                            .collection(this.projectID);
                        return [4 /*yield*/, collectionRef.doc(token).set({})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StoreService.prototype.fetchPlatformCss = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.collection(Collection.Platform).doc('CSS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch platform CSS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchPlatformJs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.collection(Collection.Platform).doc('JS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch platform JS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchFroalaCss = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.collection(Collection.Platform).doc('froalaCSS').get()];
                    case 1:
                        doc = _a.sent();
                        // eslint-disable-next-line no-undef
                        console.debug("doc " + doc);
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project CSS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectCss = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.Resources).doc('CSS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project CSS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectJs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.Resources).doc('JS').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch project JS');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectStaffAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.Resources).doc('staffAccount').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc === null || !doc.exists) {
                            return [2 /*return*/, null];
                        }
                        else if (!doc.get('value')) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchProjectStaffPassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.projectRef.collection(Collection.Resources).doc('staffPassword').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc === null || !doc.exists) {
                            return [2 /*return*/, null];
                        }
                        else if (!doc.get('value')) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.fetchLegalDocuments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.collection(Collection.Platform).doc('legalDocuments').get()];
                    case 1:
                        doc = _a.sent();
                        if (doc == null || !doc.exists) {
                            throw Error('Failed to fetch legal documents');
                        }
                        return [2 /*return*/, doc];
                }
            });
        });
    };
    StoreService.prototype.publish = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store
                            .collection(Collection.Invocation)
                            .doc(Invocation.PublishProcess)
                            .collection('i_project')
                            .doc(this.projectID)
                            .collection(this.user.uid)
                            .doc()];
                    case 1:
                        doc = _a.sent();
                        return [4 /*yield*/, (data.notifyMessage.trim() !== '' ? doc.set(data) : doc.set({}))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, doc.get()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    StoreService.prototype.changeStaffPassword = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var docRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store
                            .collection(Collection.Invocation)
                            .doc(Invocation.ChangeStaffCredentials)
                            .collection('i_project')
                            .doc(this.projectID)
                            .collection(this.user.uid)
                            .doc()];
                    case 1:
                        docRef = _a.sent();
                        return [2 /*return*/, docRef.set({ password: password })];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    StoreService.prototype.changeAdminPassword = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var docRef;
            return __generator(this, function (_a) {
                docRef = this.store
                    .collection(Collection.Invocation)
                    .doc(Invocation.ChangeAccountCredentials)
                    .collection('i_project')
                    .doc(this.projectID)
                    .collection(this.user.uid)
                    .doc();
                return [2 /*return*/, docRef.set({ password: password })];
            });
        });
    };
    return StoreService;
}());
export { StoreService };
//# sourceMappingURL=StoreService.js.map